import { CustomerVolumeRequestValidation } from '@cemex-core/cmx-api/models/customer-volume-management/customer-volume-validation-request';
import { Action } from '@ngrx/store';
import { VolumeAllocation } from '../reducers/volume-allocation.reducer';

export enum ActionTypes {
  SET_VOLUME_MANAGEMENT = '[MOO DCO] Get volume management',
  SET_VOLUME_MANAGEMENT_SUCCESS = '[MOO DCO] Get volume management success',
  SET_VOLUME_MANAGEMENT_ERROR = '[MOO DCO] Get volume management error',
  RESET_VOLUME_MANAGEMENT = '[MOO DCO] Reset Volume Management',
  LOADING_VOLUME_MANAGEMENT = '[MOO DCO] Get volume management loading',
}

export class SetVolumeManagement implements Action {
  readonly type = ActionTypes.SET_VOLUME_MANAGEMENT;
  constructor(public payload: CustomerVolumeRequestValidation) {}
}
export class SetVolumeManagementSuccess implements Action {
  readonly type = ActionTypes.SET_VOLUME_MANAGEMENT_SUCCESS;
  constructor(public payload: VolumeAllocation) {}
}
export class SetVolumeManagementError implements Action {
  readonly type = ActionTypes.SET_VOLUME_MANAGEMENT_ERROR;
  constructor() {}
}
export class SetVolumeManagementLoading implements Action {
  readonly type = ActionTypes.LOADING_VOLUME_MANAGEMENT;
  constructor() {}
}

export class ResetVolumeManagement implements Action {
  readonly type = ActionTypes.RESET_VOLUME_MANAGEMENT;
  constructor() {}
}

export type Actions =
  | SetVolumeManagement
  | SetVolumeManagementSuccess
  | SetVolumeManagementError
  | SetVolumeManagementLoading
  | ResetVolumeManagement;
